module.exports = __webpack_public_path__ + "static/media/8_avatar.ab143436.png";